import React from "react";
import { BhiDialog } from 'src/UIKit/components/Dialog';
import {
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

type BannedWordsModalProps = {
  isOpen: boolean;
  onCancel: React.Dispatch<React.SetStateAction<void>>;
  onConfirm: React.Dispatch<React.SetStateAction<void>>;
};

const BannedWordsModal = (props: BannedWordsModalProps) => {
  return (
    <BhiDialog open={props.isOpen} style={{padding: "10px"}}>
      <DialogContent>
      Restricted words or phrases were found within your message content. Consider updating your message to better comply with carrier best practices.
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={() => {
            props.onConfirm();
          }}
          color="error"
        >
          Continue Anyways
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            props.onCancel();
          }}
          color="secondary"
        >
          Edit Message
        </Button>
      </DialogActions>
    </BhiDialog>
  );
};

export default BannedWordsModal;
